import { apiGet } from '../../api';
import { BaseResponse } from '../../api/types';

import {
  BrandingDataResponse,
  ExportDataResponse,
  GetPolicyContentQuery,
  PolicyData,
  SearchPoliciesQuery,
  SearchPoliciesResponse,
} from './types';

export class PolicyAPI {
  static async getContent(
    orgId: string,
    policyId: string,
    vid: string,
    params: GetPolicyContentQuery
  ) {
    return apiGet<BaseResponse<PolicyData>>(
      `policy-portal/content/${encodeURIComponent(orgId)}/${encodeURIComponent(policyId)}/${encodeURIComponent(vid)}`,
      { params }
    );
  }

  static async search(params: SearchPoliciesQuery) {
    const id = encodeURIComponent(params.orgId);
    return apiGet<BaseResponse<SearchPoliciesResponse>>(
      `policy-portal/listing/${id}`,
      { params }
    );
  }

  static async getFile(fileName: string) {
    return apiGet<Blob>(fileName, {
      headers: {
        'no-auth': true,
      },
      responseType: 'blob',
    });
  }

  static async getExportData(
    orgIdParam: string,
    policyIdParam?: string,
    versionIdParam?: string
  ) {
    const orgId = encodeURIComponent(orgIdParam);
    if (!policyIdParam || !versionIdParam) {
      return apiGet<BaseResponse<ExportDataResponse>>(
        `policy-portal/export/${orgId}`
      );
    }

    const policyId = encodeURIComponent(policyIdParam);
    const versionId = encodeURIComponent(versionIdParam);
    return apiGet<BaseResponse<ExportDataResponse>>(
      `policy-portal/export/${orgId}/${policyId}/${versionId}`
    );
  }

  static async getBrandingData(orgId?: string) {
    return apiGet<BaseResponse<BrandingDataResponse>>(
      `policy-portal/branding/${orgId}`
    );
  }
}
